import { Constants } from '../_constants/shared.constants';

export const successLoader = (data) => {
    console.log("action loader ", data);
    return { type: Constants.loader.LOADER_REQUESTER, data }
}